import { render, staticRenderFns } from "./ExamineMag.vue?vue&type=template&id=0af4ac95&scoped=true&"
import script from "./ExamineMag.vue?vue&type=script&lang=js&"
export * from "./ExamineMag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af4ac95",
  null
  
)

export default component.exports